const appearanceInbox = {
  baseTheme: {
    variables: {
      // Modern Dabur theme - fresh, clean, vibrant
      colorBackground: "#FFFFFF",
      colorForeground: "#0f6621",
      colorPrimary: "#52B12F", // Bright success green
      colorSecondary: "#4B975B",
      colorCounter: "#FF4444", // Vibrant red for badges
      colorCounterForeground: "#FFFFFF",
      fontSize: "14px",
      borderRadius: "12px",
    },
  },
  elements: {
    // ============================================
    // BELL ICON & BADGE - Modern, Eye-catching
    // ============================================
    bellIcon: {
      fill: "#0f6621",
      width: "26px",
      height: "26px",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },

    // Unread badge - Vibrant and noticeable
    notificationBadge: {
      backgroundColor: "#FF4444",
      color: "#FFFFFF",
      fontSize: "11px",
      fontWeight: "700",
      padding: "2px 6px",
      borderRadius: "10px",
      border: "2px solid #FFFFFF",
      boxShadow: "0 2px 8px rgba(255, 68, 68, 0.4)",
    },

    // ============================================
    // POPOVER - Sleek Card Design
    // ============================================
    popover: {
      backgroundColor: "#FFFFFF",
      borderRadius: "20px",
      boxShadow: "0 12px 48px rgba(15, 102, 33, 0.2), 0 0 0 1px rgba(15, 102, 33, 0.08)",
      border: "none",
      maxWidth: "440px",
      width: "100%",
      overflow: "hidden",
    },

    // Header - Bold gradient with glass effect
    popoverHeader: {
      background: "linear-gradient(135deg, #52B12F 0%, #4B975B 50%, #0f6621 100%)",
      color: "#FFFFFF",
      padding: "24px 24px 20px",
      fontSize: "20px",
      fontWeight: "800",
      letterSpacing: "0.3px",
      borderBottom: "none",
      boxShadow: "0 4px 16px rgba(82, 177, 47, 0.25)",
      position: "relative",
    },

    // Notification count in header
    headerTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },

    headerBadge: {
      backgroundColor: "rgba(255, 255, 255, 0.25)",
      color: "#FFFFFF",
      padding: "4px 12px",
      borderRadius: "20px",
      fontSize: "13px",
      fontWeight: "600",
      backdropFilter: "blur(10px)",
    },

    // ============================================
    // NOTIFICATION LIST - Clean scrollable area
    // ============================================
    notificationList: {
      backgroundColor: "#FAFBFC",
      // maxHeight: "420px",
      overflowY: "auto",
      padding: "12px",
      scrollBehavior: "smooth",
    },

    // ============================================
    // NOTIFICATION ITEMS - Card-based design
    // ============================================
    notificationItem: {
      backgroundColor: "#FFFFFF",
      borderRadius: "14px",
      padding: "18px",
      marginBottom: "10px",
      border: "1px solid #E8EEE5",
      cursor: "pointer",
      transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
      position: "relative",
      overflow: "hidden",
    },

    // Hover - Lift effect with green accent
    notificationItemHover: {
      backgroundColor: "#F7FCF4",
      borderColor: "#52B12F",
      transform: "translateY(-3px) scale(1.01)",
      boxShadow: "0 8px 24px rgba(82, 177, 47, 0.15)",
    },

    // Unread - Fresh green accent with gradient bar
    notificationItemUnread: {
      backgroundColor: "#F0FAF0",
      borderLeft: "5px solid #52B12F",
      background: "linear-gradient(90deg, #F0FAF0 0%, #FFFFFF 100%)",
      boxShadow: "0 2px 12px rgba(82, 177, 47, 0.1)",
    },

    // Read - Subtle, clean
    notificationItemRead: {
      backgroundColor: "#FFFFFF",
      borderColor: "#F0F2F5",
      opacity: "0.85",
    },

    // ============================================
    // NOTIFICATION CONTENT - Typography
    // ============================================
    notificationSubject: {
      color: "#0f6621",
      fontSize: "15px",
      fontWeight: "700",
      lineHeight: "1.5",
      marginBottom: "6px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },

    notificationBody: {
      color: "#4A5568",
      fontSize: "13px",
      fontWeight: "400",
      lineHeight: "1.65",
    },

    // Timestamp - Subtle and elegant
    notificationTimestamp: {
      color: "#9CA3AF",
      fontSize: "11px",
      fontWeight: "500",
      marginTop: "10px",
      display: "flex",
      alignItems: "center",
      gap: "4px",
    },

    // ============================================
    // NOTIFICATION ICONS & BADGES
    // ============================================
    notificationDot: {
      backgroundColor: "#FF4444",
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      border: "2px solid #FFFFFF",
      flexShrink: 0,
      boxShadow: "0 0 0 3px rgba(255, 68, 68, 0.2)",
    },

    // Icon container for notification types
    notificationIcon: {
      width: "40px",
      height: "40px",
      borderRadius: "12px",
      backgroundColor: "#F0FAF0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "12px",
      flexShrink: 0,
    },

    // ============================================
    // ACTION BUTTONS - Modern CTA
    // ============================================
    notificationAction: {
      backgroundColor: "#52B12F",
      color: "#FFFFFF",
      borderRadius: "10px",
      padding: "10px 20px",
      fontSize: "13px",
      fontWeight: "700",
      border: "none",
      cursor: "pointer",
      marginTop: "14px",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 12px rgba(82, 177, 47, 0.25)",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },

    notificationActionHover: {
      backgroundColor: "#4AA029",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(82, 177, 47, 0.35)",
    },

    // Secondary action button
    notificationActionSecondary: {
      backgroundColor: "transparent",
      color: "#52B12F",
      border: "2px solid #52B12F",
      borderRadius: "10px",
      padding: "8px 18px",
      fontSize: "13px",
      fontWeight: "600",
      marginTop: "14px",
      marginLeft: "8px",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },

    notificationActionSecondaryHover: {
      backgroundColor: "#F0FAF0",
      borderColor: "#4AA029",
      color: "#4AA029",
    },

    // ============================================
    // EMPTY STATE - Beautiful, Engaging & Friendly
    // ============================================
    emptyState: {
      textAlign: "center",
      padding: "80px 40px",
      background: "linear-gradient(180deg, #F0FAF0 0%, #FFFFFF 100%)",
      borderRadius: "16px",
      margin: "20px",
      position: "relative",
      overflow: "hidden",
    },

    // Decorative background elements for empty state
    emptyStateBackground: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0.1,
      background: "radial-gradient(circle at 30% 50%, #52B12F 0%, transparent 50%), radial-gradient(circle at 70% 50%, #4B975B 0%, transparent 50%)",
      pointerEvents: "none",
    },

    emptyStateContent: {
      position: "relative",
      zIndex: 1,
    },

    emptyStateIconContainer: {
      width: "120px",
      height: "120px",
      margin: "0 auto 24px",
      background: "linear-gradient(135deg, #E8F5E3 0%, #D4ECC8 100%)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 8px 24px rgba(82, 177, 47, 0.15), inset 0 2px 12px rgba(255, 255, 255, 0.8)",
      border: "4px solid #FFFFFF",
      animation: "pulse 2s ease-in-out infinite",
    },

    emptyStateIcon: {
      fill: "#52B12F",
      width: "64px",
      height: "64px",
      opacity: "0.8",
      filter: "drop-shadow(0 2px 8px rgba(82, 177, 47, 0.2))",
    },

    // Alternative bell icon with animation
    emptyStateBellIcon: {
      fill: "#52B12F",
      width: "56px",
      height: "56px",
      opacity: "0.9",
    },

    emptyStateTitle: {
      color: "#0f6621",
      fontSize: "22px",
      fontWeight: "800",
      marginBottom: "12px",
      marginTop: "16px",
      letterSpacing: "0.2px",
      lineHeight: "1.3",
    },

    emptyStateText: {
      color: "#4B975B",
      fontSize: "16px",
      fontWeight: "600",
      marginBottom: "8px",
      lineHeight: "1.5",
    },

    emptyStateSubtext: {
      color: "#718096",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.7",
      maxWidth: "280px",
      margin: "0 auto 24px",
    },

    // Decorative elements around icon
    emptyStateDecoration: {
      position: "absolute",
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "#52B12F",
      opacity: 0.3,
    },

    // Call to action in empty state
    emptyStateCTA: {
      marginTop: "24px",
      color: "#52B12F",
      fontSize: "13px",
      fontWeight: "600",
      textDecoration: "none",
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 20px",
      borderRadius: "10px",
      backgroundColor: "#F0FAF0",
      border: "2px solid #E8F5E3",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },

    emptyStateCTAHover: {
      backgroundColor: "#E8F5E3",
      borderColor: "#52B12F",
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(82, 177, 47, 0.2)",
    },

    // Fun emoji or illustration container
    emptyStateIllustration: {
      fontSize: "72px",
      marginBottom: "20px",
      animation: "float 3s ease-in-out infinite",
    },

    // ============================================
    // LOADING STATE - Smooth spinner
    // ============================================
    loader: {
      color: "#52B12F",
      size: "32px",
    },

    loadingContainer: {
      padding: "40px",
      textAlign: "center",
    },

    // ============================================
    // SCROLLBAR - Custom green theme
    // ============================================
    scrollbar: {
      width: "6px",
    },

    scrollbarThumb: {
      backgroundColor: "#52B12F",
      borderRadius: "6px",
      transition: "background-color 0.3s ease",
    },

    scrollbarThumbHover: {
      backgroundColor: "#4AA029",
    },

    scrollbarTrack: {
      backgroundColor: "#F0F2F5",
      borderRadius: "6px",
    },

    // ============================================
    // FOOTER - Clean actions bar
    // ============================================
    popoverFooter: {
      backgroundColor: "#FAFBFC",
      borderTop: "1px solid #E8EEE5",
      padding: "16px 24px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },

    footerLink: {
      color: "#52B12F",
      fontSize: "13px",
      fontWeight: "700",
      textDecoration: "none",
      cursor: "pointer",
      transition: "all 0.3s ease",
      letterSpacing: "0.3px",
      textTransform: "uppercase",
    },

    footerLinkHover: {
      color: "#4AA029",
      transform: "translateX(2px)",
    },

    // ============================================
    // MARK AS READ BUTTON - Inline action
    // ============================================
    markAsReadButton: {
      color: "#52B12F",
      fontSize: "11px",
      fontWeight: "600",
      cursor: "pointer",
      padding: "6px 12px",
      borderRadius: "8px",
      backgroundColor: "#F0FAF0",
      border: "none",
      transition: "all 0.3s ease",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },

    markAsReadButtonHover: {
      backgroundColor: "#E3F5DC",
      color: "#4AA029",
      transform: "scale(1.05)",
    },

    // ============================================
    // PREFERENCES BUTTON - Settings icon
    // ============================================
    preferencesButton: {
      color: "#9CA3AF",
      fontSize: "13px",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },

    preferencesButtonHover: {
      color: "#52B12F",
    },

    // ============================================
    // CATEGORY FILTERS - Pill buttons
    // ============================================
    categoryFilter: {
      backgroundColor: "#F0F2F5",
      color: "#4A5568",
      padding: "8px 16px",
      borderRadius: "20px",
      fontSize: "12px",
      fontWeight: "600",
      border: "none",
      cursor: "pointer",
      marginRight: "8px",
      transition: "all 0.3s ease",
    },

    categoryFilterActive: {
      backgroundColor: "#52B12F",
      color: "#FFFFFF",
      boxShadow: "0 2px 8px rgba(82, 177, 47, 0.3)",
    },

    categoryFilterHover: {
      backgroundColor: "#E8EEE5",
      color: "#0f6621",
    },
  },
};

export default { appearanceInbox };
